import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ModalValidacionUsuarioData {
  tipoDocumento: string;
  numeroDocumento: string;
  datosContratante: any;
}

@Component({
  selector: 'app-modal-validacion-usuario',
  templateUrl: './modal-validacion-usuario.component.html',
  styleUrls: ['./modal-validacion-usuario.component.css']
})
export class ModalValidacionUsuarioComponent implements OnInit {

  esUsuario: boolean | null = null;
  cargando: boolean = false;
  resultadosValidacion: any = null;

  constructor(
    public dialogRef: MatDialogRef<ModalValidacionUsuarioComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalValidacionUsuarioData
  ) {}

  ngOnInit(): void {
    // NO cargar elección persistida - siempre mostrar la pregunta
    // El flujo debe ser siempre normal según RQ002
  }

  /**
   * Usuario respondió SI - Es usuario
   * Realizar validaciones AFILMED, SARLAFT, ADRES
   * TODO: Reemplazar datos hardcoded con llamada real al servicio
   * Endpoint esperado: POST /api/validaciones/contratante
   */
  seleccionarSi(): void {
    this.esUsuario = true;
    this.cargando = true;

    // Guardar esUsuario en localStorage inmediatamente
    this.guardarEsUsuarioEnLocalStorage(true);
    console.log('[Store-Anexo-Trace] Modal validación: SI (no toca programas_contratante)');

    // Simular carga asíncrona con datos hardcoded
    // TODO: Reemplazar con llamada real al servicio
    setTimeout(() => {
      // Datos hardcoded de validaciones
      // TODO: Reemplazar con respuesta real del servicio
      const validacionesMock = {
        sarlaft: {
          bloqueado: false,
          motivoBloqueo: '',
          perfilRiesgo: 'Bajo'
        },
        adres: {
          estadoEPS: 'Activo',
          regimen: 'Contributivo'
        }
      };

      // Formatear resultados para pasar al siguiente modal
      this.resultadosValidacion = {
        afilmed: {
          estado: 'Activo',
          contratos: 2,
          mensaje: 'Usuario con contratos activos'
        },
        sarlaft: {
          perfilRiesgo: validacionesMock.sarlaft.perfilRiesgo,
          bloqueado: validacionesMock.sarlaft.bloqueado,
          mensaje: validacionesMock.sarlaft.bloqueado 
            ? `⚠️ ${validacionesMock.sarlaft.motivoBloqueo}`
            : 'Sin restricciones'
        },
        adres: {
          estadoEPS: validacionesMock.adres.estadoEPS,
          regimen: validacionesMock.adres.regimen,
          mensaje: `Afiliado ${validacionesMock.adres.estadoEPS.toLowerCase()}`
        }
      };
      
      this.cargando = false;

      // Si está bloqueado por SARLAFT, no cerrar automáticamente
      if (validacionesMock.sarlaft.bloqueado) {
        // Mostrar error y no permitir continuar
        console.error('Usuario bloqueado por SARLAFT');
        return;
      }

      // Cerrar modal inmediatamente sin mostrar resultados
      // Los resultados se mostrarán en el modal de selección de programas
      this.cerrarConResultado(true);
    }, 500); // Simular delay de red
  }

  /**
   * Usuario respondió NO - No es usuario
   * Continuar sin validaciones adicionales
   */
  seleccionarNo(): void {
    this.esUsuario = false;

    // Guardar esUsuario en localStorage inmediatamente
    this.guardarEsUsuarioEnLocalStorage(false);

    // Si era usuario antes y había programas guardados, borrar la key (no aplica selección para "No es usuario")
    localStorage.removeItem('programas_contratante');

    // Cerrar modal inmediatamente
    this.cerrarConResultado(false);
  }

  /**
   * Guardar esUsuario en localStorage dentro de datosRQ002_Contratante
   */
  private guardarEsUsuarioEnLocalStorage(esUsuario: boolean): void {
    try {
      // Obtener datos existentes del localStorage
      const datosExistentesStr = localStorage.getItem('datosRQ002_Contratante');
      let datosExistentes: any = {};
      
      if (datosExistentesStr) {
        datosExistentes = JSON.parse(datosExistentesStr);
      }
      
      // Agregar o actualizar esUsuario
      datosExistentes.esUsuario = esUsuario;
      
      // Guardar de vuelta en localStorage
      localStorage.setItem('datosRQ002_Contratante', JSON.stringify(datosExistentes));
      console.log('esUsuario guardado en localStorage:', esUsuario);
    } catch (error) {
      console.error('Error al guardar esUsuario en localStorage:', error);
    }
  }

  /**
   * Cerrar modal con resultado
   */
  cerrarConResultado(esUsuario: boolean): void {
    this.dialogRef.close({
      esUsuario: esUsuario,
      validaciones: this.resultadosValidacion,
      datosContratante: this.data.datosContratante
    });
  }

  /**
   * Cerrar modal sin guardar (X)
   */
  cerrar(): void {
    this.dialogRef.close(null);
  }
}
